
const ConfirmEmergency = ({step }) => {

  return (
      <section className="w-full select-none">
          <div className="flex justify-center mb-8">
              <h2 className="text-2xl font-semibold text-portal-dark-blur text-center">
                  {step === 1 && 'Confirm this is not an emergency'}
                  {step === 2 && 'Book your Consultation'}
                  {step === 3 && 'Book your Consultation'}
                  {step === 4 && 'Book your Consultation'}
              </h2>
          </div>
          <div className="flex items-center justify-center space-x-4">
              <div className={`w-10 h-10 flex items-center justify-center rounded-full border-2 ${
                      step === 1 ? 'border-hub-primary text-hub-primary opacity-100' : 'border-gray-300 bg-gray-100 text-gray-500 opacity-50'
                  }`}
              >
                  1
              </div>
              <div className={`w-10 h-10 flex items-center justify-center rounded-full border-2 ${
                      step === 2 ? 'border-hub-primary text-hub-primary opacity-100' : 'border-gray-300 bg-gray-100 text-gray-500 opacity-50'
                  }`}
              >
                  2
              </div>
              <div className={`w-10 h-10 flex items-center justify-center rounded-full border-2 ${
                      step === 3 ? 'border-hub-primary text-hub-primary opacity-100' : 'border-gray-300 bg-gray-100 text-gray-500 opacity-50'
                  }`}
              >
                  3
              </div>
              <div className={`w-10 h-10 flex items-center justify-center rounded-full border-2 ${
                      step === 4 ? 'border-hub-primary text-hub-primary opacity-100' : 'border-gray-300 bg-gray-100 text-gray-500 opacity-50'
                  }`}
              >
                  4
              </div>
          </div>
      </section>
  );
};

export default ConfirmEmergency;